import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconElement(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M5 9V5h4V3H4a1 1 0 0 0-1 1v5h2ZM3 15v5a1 1 0 0 0 1 1h5v-2H5v-4H3ZM15 5V3h5a1 1 0 0 1 1 1v5h-2V5h-4ZM21 20v-5h-2v4h-4v2h5a1 1 0 0 0 1-1ZM8 7a1 1 0 0 0 0 2h8a1 1 0 1 0 0-2H8ZM8 11a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8ZM8 15a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8Z"
      />
    </BaseIcon>
  );
}
